import { Link } from 'react-router-dom'

const footerLinks = [
  { name: "Home", href: "/" },
  { name: "Categories", href: "/categories" },
  { name: "Search", href: "/search" },
  { name: "Sources", href: "/sources" },
  { name: "Regional", href: "/regional" },
  { name: "Help", href: "/help" },
]

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="container flex flex-col sm:flex-row items-center justify-between gap-2 py-4">
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span>&copy; {new Date().getFullYear()} US Economic</span>
        </div>
        <nav className="flex items-center gap-4">
          {footerLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.name}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  )
}
